import Item from 'common/ITEMS/Item';

const items = {
  //region Havoc
  //endregion
  //region Vengeance
  //endregion
  //region Shared
  //endregion
} satisfies Record<string, Item>;
export default items;
